import { useEffect } from "react"
import { motion } from "motion/react"
import { IconXmarkOutline18 as X } from "nucleo-ui-outline-18"
import { createPortal } from "react-dom"

import { VideoPlayer } from "../video-player"

interface VideoLightboxProps {
	src: string
	onClose: () => void
}

export function VideoLightbox({ src, onClose }: VideoLightboxProps) {
	useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (e.key !== "Escape") return
			e.preventDefault()
			e.stopPropagation()
			onClose()
		}
		document.addEventListener("keydown", onKeyDown, true)
		return () => document.removeEventListener("keydown", onKeyDown, true)
	}, [onClose])

	return createPortal(
		<motion.div
			role="dialog"
			aria-modal="true"
			className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 p-8 backdrop-blur-sm"
			onClick={onClose}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
		>
			<button
				type="button"
				aria-label="Close"
				className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
				onClick={onClose}
			>
				<X />
			</button>
			<motion.div
				className="w-full max-w-4xl"
				onClick={(e) => e.stopPropagation()}
				initial={{ opacity: 0, scale: 0.96 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
			>
				<VideoPlayer src={src} autoPlay className="max-h-[80vh] w-full" />
			</motion.div>
		</motion.div>,
		document.body,
	)
}
